// extracted by mini-css-extract-plugin
export default {"page":"month-page_page__BvCAh"};